module.exports = __webpack_public_path__ + "static/dash-daq-4cf7d526ed30c7dad68b1ae7a25e5187.png";